import { QueryKey, useMutation, UseQueryResult } from '@tanstack/react-query'
import { queryClient, QueryOptions, UseMutationResult, useResource, useResources } from '.'
import {
  create,
  fetch,
  get,
  WorkPeriodTag,
  WorkPeriodTagCreationPayload,
  WorkPeriodTagUpdatePayload,
  update,
} from '../api/work-period-tags'

//Queries
export const useWorkPeriodTagQuery = (
  id?: string,
  options?: QueryOptions,
): UseQueryResult<WorkPeriodTag, any> =>
  useResource<WorkPeriodTag>('work-period-tags', get, id, undefined, options)

export const useWorkPeriodTagsQuery = (
  filters?: any,
  options?: QueryOptions,
): UseQueryResult<WorkPeriodTag[], any> =>
  useResources<WorkPeriodTag[], any>('work-period-tags', fetch, filters, options)

//Mutations
const onMutationSuccess = () => {
  queryClient.invalidateQueries(['work-period-tags'])
}

export const useCreateMutationKey = (): QueryKey => ['work-period-tags', 'create']
export const useCreateMutation = (): UseMutationResult<
  WorkPeriodTag,
  WorkPeriodTagCreationPayload,
  any
> => useMutation(create, { mutationKey: useCreateMutationKey(), onSuccess: onMutationSuccess })

export const useUpdateMutationKey = (): QueryKey => ['work-period-tags', 'update']
export const useUpdateMutation = (): UseMutationResult<
  WorkPeriodTag,
  WorkPeriodTagUpdatePayload,
  any
> =>
  useMutation(update, {
    mutationKey: useUpdateMutationKey(),
    onSuccess: onMutationSuccess,
  })

export const invalidateWorkPeriodTagsQueries = (): void => {
  queryClient.invalidateQueries(['work-period-tags'])
}
